import styled, { css } from 'styled-components';
import Container from '../Container';
export const IconContainerContent = styled(Container) `
  position: relative;
  & > * {
    position: relative;
    z-index: 1;
  }
  & > svg {
    z-index: 0 !important;
  }
`;
export const IconStyled = styled.div `
  ${({ $params }) => {
    const { inversed, rotate, top = 0, side, margin = 0, width, height, } = $params;
    return css `
      display: block;
      position: absolute;
      zindex: -1;
      top: ${top}px;
      ${side === 'right' ? `right: ${margin}px;` : `left: ${margin}px;`}
      ${inversed ? `scale: -1 1;` : ''}
      ${!!rotate && rotate != 0 ? `rotate:  ${rotate}deg;` : ''}

      width: ${width}px;
      height: ${height}px;
      & > svg {
        width: 100%;
        height: 100%;
      }
    `;
}}
`;
